// packages block
import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog, Typography, Box } from "@material-ui/core";
// common block
import "./style.css";
import { FormButton } from "../form";
import { preaddStyles } from "./styles";
// constants, theme, utils and api block
import { BLUE_EIGHT, WHITE } from "../../theme";

export const OnSuccessDialog = ({
  open,
  goHome,
  viewDetailWithGenrateDialogue,
  isEditedItem,
  title,
  editCallback,
  studentTitle,
  invoiceTitle,
}) => {
  const classes = preaddStyles();
  const { t } = useTranslation();

  return (
    <Dialog
      style={{ maxWidth: "400px", margin: "auto" }}
      className={classes.root}
      // onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <div className="success_card">
        {title === t("text_user") ? (
          <>
            {editCallback === "edit" ? (
              <Typography variant="h2">{t("text_successfully_updated")}</Typography>
            ) : (
              <>
                <Typography variant="h2">{t("text_successfully_created")}</Typography>
              </>
            )}
          </>
        ) : (
          <>
            {studentTitle === "studentCreate" ? (
              <Typography variant="h2">{t("text_successfully")}</Typography>
            ) : (
              <>
                {invoiceTitle === "notifyParent" ? (
                  <Typography variant="h2">
                    Notifications sent successfully
                  </Typography>
                ) : (
                  <Typography variant="h2">
                    {t("text_changes_saved_successfully")}
                  </Typography>
                )}
              </>
            )}
          </>
        )}

        <div className="success_message">
          {title === t("text_user") ? (
            <>
            </>
          ) : (
            <>
              <span
                className="link"
                onClick={() => viewDetailWithGenrateDialogue(isEditedItem)}
              >
              </span>
            </>
          )}
        </div>

        <Box marginTop={2} display="flex" justifyContent="center">
          <FormButton
            title={t("text_ok")}
            onClickHandler={goHome}
            height={40}
            width={"10vw"}
            borderTopRightRadius={15}
            borderTopLeftRadius={15}
            borderBottomLeftRadius={15}
            borderBottomRightRadius={15}
            backgroundColor={BLUE_EIGHT}
            titleColor={WHITE}
            hoverTitleColor={BLUE_EIGHT}
            hoverBackgroundColor={WHITE}
            hoverBorderColor={BLUE_EIGHT}
            style={{ fontSize: "0.8vw", fontWeight: "700" }}
          />
        </Box>
      </div>
    </Dialog>
  );
};
